<template>
	<div class="settlementRecords mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">结算记录</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disStart">
				<span class="title">结算记录</span>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
								<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
								<!-- <el-select clearable v-model="searchObj.communityId" allow-create filterable remote
									reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod1"
									@change="changeSelect1">
									<el-option v-for="item in restaurants" :key="item.communityId"
										:label="item.communityName" :value="item.communityId">
									</el-option>
								</el-select> -->
						</div>
						<!-- <div class="myinputBox">
							<div class="myinputBox">
								<el-select clearable v-model="searchObj.communitySiteId" slot="prepend"
									placeholder="请选择充电站">
									<el-option v-for="(item,inx) in stationList" :key="inx"
										:label="item.communitySiteName" :value="item.communitySiteId"></el-option>
								</el-select>
							</div>
						</div> -->
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityEquipment" placeholder="请输入设备编号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-cascader clearable ref="cascader1"
								:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}" v-model="areaValue"
								:options="areaList" @change="handleChange($event,1)" placeholder="请选择所在地区">
							</el-cascader>
						</div>
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityEquipment" placeholder="请输入人员编号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.checkFlag" slot="prepend" placeholder="请选择处理状态">
								<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<!-- <el-button type="success">导出</el-button> -->
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentName" label="设备名称">
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="communitySiteName" label="所属站点">
							</el-table-column> -->
							<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="faultTime" label="所属地区" width="150">
								<template slot-scope="scope">
									{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}
								</template>
							</el-table-column>
							<el-table-column prop="dispatchTime" label="派单时间" width="150">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserName" label="运维人员"></el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserNo" label="人员编号">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="checkFlag" label="处理状态">
								<template slot-scope="scope">
									<span>{{getStatus(scope.row.checkFlag,operateStatusList)}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="realOrderFees" label="结算">
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange($event,1)">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../assets/js/common.js"
	export default {
		name: "settlementRecords",
		components: {},
		data() {
			return {
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				NOfalse: false,
				templateSelection: "",
				operateStatusList: [{
						text: "待派单",
						value: -1
					},
					{
						text: "未处理",
						value: 0
					},
					{
						text: "已解决 待审核",
						value: 1
					},
					{
						text: "无法解决 待审核",
						value: 2
					},
					{
						text: "已完成",
						value: 3
					},
					{
						text: "未完成",
						value: 4
					},
					{
						text: "审核不通过 待处理",
						value: 5
					}
				],
				tableData: [],
				stationList: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					communityName: "", //社区名称
					communitySiteName: "", //站点名称
					communityEquipment: "", //设备编号/名称
					orderStatus: '', //处理状态 1待处理 2已完成
					startTime: '', //开始时间
					endTime: '', //结束时间
					checkFlag:"",
					searchData: [],
				},
				restaurants: [],
				options: [],
				areaValue: '',
				areaList: [],
			}
		},
		mounted() {
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
				this.getData()
			})
		},
		methods: {
			getStatus(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				}) || {}
				return obj.text || ""
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			remoteMethod1(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect1(n) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}

			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.paramConfigItemId
				}) || {}
				return obj.paramConfigItemName || ""
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listSettlementRecord(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val, n) {
				if (n == 1) {
					this.$set(this.PageInfo,"pagenum",val)
					this.$set(this.searchObj,"pageNo",val)
					this.getData({})
				} else {

				}

			},
			handleChange(value, n) {
				
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
				} else {
					this.$set(this.searchObj, "provinceCode", "")
					this.$set(this.searchObj, "cityCode", "")
					this.$set(this.searchObj, "areaCode", "")
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./settlementRecords.scss";
</style>